module.exports = __webpack_public_path__ + "static/media/fa-regular-400.c794369e.svg";